import {
  DataListingRequestStatus,
  GetEmployeesPayload,
  SearchForeignersPayload,
  GetUsersPayload,
  PaginatedResponse,
  ReassignForeignersOpts,
  Role,
  SelfRegisterOpts,
  User,
  USER_TAGS,
} from '@interfaces';
import { createAction, props } from '@ngrx/store';
import { DataListingRequest } from '@interfaces';

// searchForeigners use 'getUsersSuccess' on success
export const searchForeigners = createAction('[Users] Get Foreigners', props<{ payload: SearchForeignersPayload }>());
// getEmployees use 'getUsersSuccess' on success
export const getEmployees = createAction('[Users] Get Employees', props<{ payload: GetEmployeesPayload }>());

// getCompanyEmployees use 'getUsersSuccess' on success - used by managers
// companyId in payload is ignored - backend is fetching companyId from requesting user object
export const getCompanyEmployees = createAction('[Users] Get Company Employees', props<{ payload: GetUsersPayload }>());

export const getUsers = createAction('[Users] Get Users', props<{ payload: GetUsersPayload }>());
export const getUsersSuccess = createAction('[Users] Get Users Success', props<{ users: PaginatedResponse<User> }>());
export const getUsersError = createAction('[Users] Get Users Error', props<{ errorMessage: string }>());

export const getForeignerBasicData = createAction('[Users] Get Foreigner Basic Data', props<{ foreignerId: string }>());
export const getForeignerBasicDataSuccess = createAction(
  '[Users] Get Foreigner Basic Data SUCCESS',
  props<{ foreigner: Partial<User> }>()
);
export const getForeignerBasicDataError = createAction(
  '[Users] Get Foreigner Basic Data ERROR',
  props<{ errorMessage: string }>()
);
export const resetLoadedForeignerBasicData = createAction('[Users] Reset loaded foreigner basic data in store');

export const getEmployeeBasicData = createAction('[Users] Get Employee Basic Data', props<{ employeeId: string }>());
export const getEmployeeBasicDataSuccess = createAction(
  '[Users] Get Employee Basic Data SUCCESS',
  props<{ employee: Partial<User> }>()
);
export const getEmployeeBasicDataError = createAction(
  '[Users] Get Employee Basic Data ERROR',
  props<{ errorMessage: string }>()
);
export const resetLoadedEmployeeBasicData = createAction('[Users] Reset loaded employee basic data in store');

// createForeigner use 'createUserSuccess' on success
// processId?: [uuid] or null
export const createForeigner = createAction('[Users] Create Foreigner', props<{ payload: Partial<User> }>());
// createEmployee use 'createUserSuccess' on success
export const createEmployee = createAction('[Users] Create Employee', props<{ payload: Partial<User> }>());

export const createUserSuccess = createAction('[Users] Create User Success', props<{ createdUser: User }>());
export const createUserError = createAction('[Users] Create User Error', props<{ errorMessage: string }>());

export const resendEmployeeActivation = createAction(
  '[Users] Resend employee activation link',
  props<{ email: string; userId: string }>()
);
export const resendForeignerActivation = createAction(
  '[Users] Resend foreigner activation link',
  props<{ email: string; userId: string }>()
);

export const resendActivationSuccess = createAction(
  '[Users] Resend activation link success',
  props<{ emailSent: boolean }>()
);
export const resendActivationError = createAction(
  '[Users] Resend activation link error',
  props<{ errorMessage: string }>()
);

// updateForeigner use 'updateUserSuccess' on success
export const updateForeigner = createAction(
  '[Users] Update Foreigner',
  props<{ payload: Partial<User>; userId: string }>()
);
// updateEmployee use 'updateUserSuccess' on success
export const updateEmployee = createAction(
  '[Users]  Update Employee',
  props<{ payload: Partial<User>; userId: string }>()
);

export const updateUserSuccess = createAction('[Users] Update User Success', props<{ updatedUser: User }>());
export const updateUserError = createAction('[Users] Update User Error', props<{ errorMessage: string }>());

// removeForeigner use 'removeUserSuccess' on success
export const removeForeigner = createAction('[Users] Remove Foreigner', props<{ userId: string }>());
// removeEmployee use 'removeUserSuccess' on success
export const removeEmployee = createAction('[Users]  Remove Employee', props<{ userId: string }>());

export const removeUserSuccess = createAction('[Users] Remove User Success', props<{ removedUserId: string }>());
export const removeUserError = createAction('[Users] Remove User Error', props<{ errorMessage: string }>());

export const restoreUser = createAction('[Users] Restore User', props<{ userId: string }>());

export const restoreForeigner = createAction('[Users] Restore Foreigner', props<{ foreignerId: string }>());
export const restoreUserSuccess = createAction(
  '[Users] Restore User Success',
  props<{ restoredUser: Partial<User> }>()
);

export const restoreUserError = createAction('[Users] Restore User Error', props<{ errorMessage: string }>());

export const getEmployeeTypes = createAction('[Users] Get Employee Types');
export const getEmployeeTypesSuccess = createAction(
  '[Users] Get Employee Types Success',
  props<{ employeeTypes: Role[] }>()
);
export const getEmployeeTypesError = createAction('[Users] Get Employee Types Error');

export const selfRegister = createAction('[Users] Self Register', props<{ opts: SelfRegisterOpts }>());
export const selfRegisterSuccess = createAction('[Users] Self Register Success');
export const selfRegisterError = createAction('[Users] Self Register Error', props<{ errorMessage: string }>());
export const getAllRoles = createAction('[Users] Get All Roles');
export const getAllRolesSuccess = createAction('[Users] Get All Roles Success', props<{ allRoles: Role[] }>());
export const getAllRolesError = createAction('[Users] Get All Roles Error');

export const reassignForeigners = createAction(
  '[Users] Reassign foreigners',
  props<{ opts: ReassignForeignersOpts }>()
);
export const reassignForeignersSuccess = createAction('[Users] Reassign foreigners Success');
export const reassignForeignersError = createAction('[Users] Reassign foreigners Error');

export const modifyUsersTags = createAction(
  '[Users] Modify Users Tags',
  props<{ payload: { userIds: string[]; tags: Partial<Record<USER_TAGS, boolean>> } }>()
);
export const modifyUsersTagsSuccess = createAction(
  '[Users] Modify Users Tags Success',
  props<{ usersTags: Partial<User>[] }>()
);
export const modifyUsersTagsError = createAction('[Users] Modify Users Tags Error', props<{ errorMessage: string }>());

export const getAllRequestsDataListing = createAction('[Users] Get All Requests Data Listing');
export const getAllRequestsDataListingSuccess = createAction(
  '[Users] Get All Requests Data Listing Success',
  props<{ dataListingRequests: DataListingRequest[] }>()
);
export const getAllRequestsDataListingError = createAction('[Users] Get All Requests Data Listing Error');

export const getDataListingRequestsOfUser = createAction(
  '[Users] Get Data Listing Requests Of User',
  props<{ payload: { userId: string } }>()
);
export const getDataListingRequestsOfUserSuccess = createAction(
  '[Users] Get Data Listing Requests Of User Success',
  props<{ dataListingRequests: DataListingRequest[] }>()
);
export const getDataListingRequestsOfUserError = createAction('[Users] Get Data Listing Requests Of User Error');

export const requestDataListing = createAction('[Users] Request Data Listing');
export const requestDataListingSuccess = createAction(
  '[Users] Request Data Listing Success',
  props<{ dataListingRequest: DataListingRequest }>()
);
export const requestDataListingError = createAction('[Users] Request Data Listing Error');

export const changeDataListingRequestStatus = createAction(
  '[Users] Change Data Listing Request Status',
  props<{ payload: { dataListingRequestId: string; status: DataListingRequestStatus } }>()
);
export const changeDataListingRequestStatusSuccess = createAction(
  '[Users] Change Data Listing Request Status Success',
  props<{ dataListingRequest: DataListingRequest }>()
);
export const changeDataListingRequestStatusError = createAction('[Users] Change Data Listing Request Status Error');

export const getUserConsents = createAction('[Users] Get User Consents');
export const getUserConsentsSuccess = createAction(
  '[Users] Get User Consents Success',
  props<{ userConsents: Partial<User> }>()
);
export const getUserConsentsError = createAction('[Users] Get User Consents Error', props<{ errorMessage: string }>());
